module.exports = __webpack_public_path__ + "static/media/destinationInfoSkeletonSm.30ffc6a8.svg";